import React from "react";
import SearchDropDown from "../SearchDropDown/SearchDropDown";
import { useSelector } from "react-redux";

const ABSFilter = ({ isChild = false, ...props }) => {
  // HRM = Child and ABS = parent
  const { loading: HRMsLoading, hrmDetails } = useSelector(
    (state) => state.getHRMDetailsReducer
  );
  const { loading: ABSLoading, absList } = useSelector(
    (state) => state.absReducer
  );

  return (
    <SearchDropDown
      isChild={isChild}
      list={isChild ? hrmDetails : absList}
      loading={isChild ? HRMsLoading : ABSLoading}
      {...props}
    />
  );
};

export default ABSFilter;
